/* eslint-disable */
import DetectBlocker from './lib/blocker';

{
  consenter.loadJS('cleverpush', 'https://static.cleverpush.com/channel/loader/zZPHBx2T88XzMEjWx.js', 4);
  new DetectBlocker();
}
